import clsx from 'clsx'
import React, { FC } from 'react'

import CheckIcon from '@Assets/SVG/CheckRounded'
import { SVGIcon } from '@Components/Icons/SVGIcon'
import { RTEContent } from '@Components/RTEContent'
import { useTranslation } from '@Globals/Translations'

import styles from './Subscribed.module.scss'

interface SubscribedProps {
  className?: string
  id?: string
  message?: string
}

export const Subscribed: FC<SubscribedProps> = ({ className, id, message }) => {
  const { t } = useTranslation()
  const text = message || t('cms:GREAT_WE_WILL_NOTIFY_YOU')

  return (
    <div className={clsx(styles.subscribed, className)} id={id}>
      <SVGIcon icon={CheckIcon} size="47px" />
      <div className={styles.subscribedContent}>
        {text && <RTEContent html={text} />}
      </div>
    </div>
  )
}
